import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
import { Flex, Input, InputRef, Space, Typography } from "antd";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
// import { customLogger } from "../../../utils/Logger";
// import { generateHexUdid } from "../../../utils";
// import { auth } from "../../../firebase/firebase";
// import apiInstance from "../../../services/apiService";
import "./index.scss";

const { Text, Title } = Typography; 

interface OTPVerificationProps {
  handleVerify: (otp: string) => void;
  loading?: boolean;
  email: string;
}

const OTPVerification: React.FC<OTPVerificationProps> = ({
  handleVerify,
  loading,
  email,
}) => {
  const [timer, setTimer] = useState<number>(59);
  const [otp, setOtp] = useState<string[]>(new Array(6).fill(""));
  const inputRefs = useRef<InputRef[]>([]);

  const handleSubmitOtp = async (code: string[]) => {
    const accessCode = code.join("");
    handleVerify(accessCode);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (e.target.value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    const isOtpComplete = newOtp.every((digit) => digit !== "");
    if (isOtpComplete) {
      handleSubmitOtp(newOtp);
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "Enter") {
      const isOtpComplete = otp.every((digit) => digit !== "");
      if (isOtpComplete) {
        handleSubmitOtp(otp);
      }
    }
  };

  //   const resendOTPfromBackend = async () => {
  //     const url = "auth/app/sendOtpForNumber";

  //     try {
  //       const response = await apiInstance.post(url, { phoneNumber });
  //       if (response.status === 200) {
  //         toast.info("OTP has been sent successfully");
  //         setTimer(59);
  //       }
  //     } catch (err: any) {
  //       customLogger("error sending OTP from Backend", err);
  //       toast.error(err.message || "There was an error. Please try again");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   const handleResend = async () => {
  //     if (loading) return;

  //     setLoading(true);

  //     if (otpSentFromBackend) {
  //       resendOTPfromBackend();
  //     } else {
  //       try {
  //         const appVerifier = window.recaptchaVerifier;

  //         if (!appVerifier) {
  //           toast.error("ReCAPTCHA verifier not initialized. Please refresh.");
  //           return;
  //         }

  //         const confirmationResult = await signInWithPhoneNumber(
  //           auth,
  //           phoneNumber || "",
  //           appVerifier,
  //         );

  //         window.confirmationResult = confirmationResult;
  //         toast.success("OTP sent successfully!");
  //         setTimer(59);
  //       } catch (error: any) {
  //         console.error("Error sending OTP:", error);
  //         toast.error(error.message || "Failed to send OTP");
  //       } finally {
  //         setLoading(false);
  //       }
  //     }
  //   };

  useEffect(() => {
    if (timer <= 0) return;

    const timeout = setTimeout(() => {
      setTimer(timer - 1);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [timer]);

  //   useEffect(() => {
  //     if (!window.recaptchaVerifier) {
  //       window.recaptchaVerifier = new RecaptchaVerifier(
  //         auth,
  //         "recaptcha-container",
  //         {
  //           size: "invisible",
  //         },
  //       );

  //       window.recaptchaVerifier.render().catch((err) => {
  //         console.error("Failed to render reCAPTCHA:", err);
  //       });
  //     }

  //     return () => {
  //       if (window.recaptchaVerifier) {
  //         window.recaptchaVerifier.clear();
  //         window.recaptchaVerifier = undefined;
  //       }
  //     };
  //   }, []);

  //   useEffect(() => {
  //     const el = document.getElementById("recaptcha-container");
  //     customLogger("Recaptcha container present:", !!el);
  //   }, []);
  if (!email) return null;

  return (
    <div className="verify-otp-container">
      <div>
        <img src="/assets/images/lock-icon.svg" alt="" />
      </div>

      <Title className="page-title">Email verification</Title>

      <Text className="sub-text">
        We’ve sent a code to {email}. <br /> Verify email to secure and to backup
        account
      </Text>

      <Flex gap={16}>
        {otp.map((digit, index) => (
          <Input
            key={index}
            disabled={loading}
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className="otp-input"
            ref={(el) => {
              if (el) inputRefs.current[index] = el;
            }}
          />
        ))}
      </Flex>

      <Text className="recieve-otp">
        Didn't recieve OTP code?{" "}
        <br />
        <span  className="resend">
          Resend OTP
        </span>
      </Text>

      <div id="recaptcha-container"></div>
    </div>
  );
};

export default OTPVerification;
